import DallasSvgIcon from '@ui/Dallas/Icons/DallasSvgIcon';
import NavButton from './NavButton';
import NavLink from './NavLink';
import DallasStack from '@ui/Dallas/Stack/DallasStack';
import DallasText from '@ui/Dallas/Text/DallasText';
import styles from './NavItem.module.scss';
import clsx from 'clsx';

export interface Props {
  className?: string;
  icon: React.ReactElement<typeof DallasSvgIcon>;
  label: string;
  children: (
    | React.ReactElement<typeof NavLink>
    | React.ReactElement<typeof NavButton>
    | boolean
  )[];
}

export default function NavItemGroup({ children, label, icon }: Props) {
  return (
    <DallasStack className={styles.group} gap="2xs">
      <div className={clsx(styles.root, styles.header)}>
        {icon}
        <DallasText className={styles.label} align="start">
          {label}
        </DallasText>
      </div>
      <DallasStack className={styles.items} gap="2xs">
        {children}
      </DallasStack>
    </DallasStack>
  );
}
